// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable no-negated-condition, prefer-named-capture-group, react/destructuring-assignment, react/sort-comp, react/jsx-handler-names, no-constant-condition */
import React, { PureComponent } from "react"
import * as cookies from "@kiwicom/cookies"
import { connect } from "react-redux"

import { getScrollingElement } from "../../utils/scrollUtils"
import { throttleTrailing } from "../../utils/fpThrottleWithOptions"
import MobileAdComponent from "./MobileAdComponent"
import translate from "../../../../app/scripts/tools/translate"
import { setOption } from "../../services/options/actions"

const isiOS =
  typeof window !== "undefined" ? /(iPhone|iPad|iPod)/i.test(window.navigator.userAgent) : false
// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/prefer-includes
const isAndroid = typeof window !== "undefined" ? /Android/.test(window.navigator.userAgent) : false

type Props = {
  showMobileAd: boolean
  setOption: (
    arg1: string,
    arg2: boolean,
  ) => {
    type: string
    option: string
    value: boolean
  }
}

type State = {
  hidden: boolean
}

class MobileAd extends PureComponent<Props, State> {
  state = {
    hidden: false,
  }

  componentDidMount() {
    if (
      (isAndroid || isiOS) &&
      !cookies.load("ignore_mobile_ad") &&
      !cookies.load("SKYPICKER_AFFILIATE")
    ) {
      this.props.setOption("showMobileAd", true)
    }

    window.addEventListener("scroll", this.handleScroll)

    this.handleScroll()
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll)
  }

  onClose = () => {
    this.props.setOption("showMobileAd", false)
    cookies.save("ignore_mobile_ad", "true")
  }

  // FIXME: sort methods in React components according to conventions

  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/member-ordering
  handleScroll = throttleTrailing(100, () => {
    const { showMobileAd } = this.props

    if (!showMobileAd) {
      return
    }

    const scrollEl = getScrollingElement()

    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (!scrollEl) {
      return
    }

    const { hidden } = this.state

    const treshold = 100
    const isBottom = scrollEl.scrollHeight - scrollEl.clientHeight - scrollEl.scrollTop <= treshold

    if (isBottom) {
      if (!hidden) {
        this.setState({ hidden: true })
      }
    } else if (hidden) {
      this.setState({ hidden: false })
    }
  })

  render() {
    if (this.state.hidden || !this.props.showMobileAd) {
      return null
    }
    if (isAndroid) {
      return (
        <MobileAdComponent
          onClose={this.onClose}
          title="Kiwi.com - Android app"
          store={`${translate(
            "support.passenger-details.correct-details.common.free",
          )} - Google Play`}
          link="https://getapp.kiwi.com/EYSq?deep_link_value=https%3A%2F%2Fkiwi.com%2Fmobile%3Futm_campaign%3Dsticky_footer_smart_banner%26utm_medium%3Dwebsite%26utm_source%3Dproduct%26utm_content%3Dandroid&c=sticky_footer_smart_banner&af_channel=website&pid=product&af_ad=android"
        />
      )
    }
    // disabled for now, native promotion is currently being used

    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (false && isiOS) {
      return (
        <MobileAdComponent
          onClose={this.onClose}
          title="Kiwi.com - iOS app"
          store={`${translate(
            "support.passenger-details.correct-details.common.free",
          )} - App Store`}
          link="https://getapp.kiwi.com/EYSq?deep_link_value=https%3A%2F%2Fkiwi.com%2Fmobile%3Futm_campaign%3Dsticky_footer_smart_banner%26utm_medium%3Dwebsite%26utm_source%3Dproduct%26utm_content%3Dios&c=sticky_footer_smart_banner&af_channel=website&pid=product&af_ad=ios"
        />
      )
    }
    return null
  }
}

export default connect(
  (state) => ({
    // @ts-expect-error: Flow to TS migration.
    showMobileAd: state.options.get("showMobileAd"),
  }),
  {
    setOption,
  },
)(MobileAd)
